import { Link, useLocation } from "react-router-dom";
import { useState } from "react";
import { toast } from "react-toastify";

import {
  AttachMoney,
  ChatBubbleOutline,
  DynamicFeed,
  Equalizer,
  LineStyle,
  MailOutline,
  PermIdentity,
  Report,
  Storefront,
  Timeline,
  TrendingUp,
  WorkOutline,
} from "@material-ui/icons";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import FactCheckOutlinedIcon from "@mui/icons-material/FactCheckOutlined";
import PlaylistAddCheckOutlinedIcon from "@mui/icons-material/PlaylistAddCheckOutlined";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
// import { MenuOpenIcon, MenuIcon } from "@mui/icons-material"; //is not working ??
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import MenuIcon from "@mui/icons-material/Menu";
import CurrencyBitcoinIcon from "@mui/icons-material/CurrencyBitcoin";
import AddAlertIcon from "@mui/icons-material/AddAlert";

import "./sidebar.css";
import SidebarTooltip from "../sidebarTooltip/SidebarTooltip";
import SettingsDlg from "../crudSql/settingsDlg/SettingsDlg";

export default function Sidebar(props) {
  const [hideSidebar, setHideSidebar] = useState(true);
  const toggleSidebar = () => {
    setHideSidebar((state) => !state);
  };

  // const [settingsWalletAbbr, setSettingsWalletAbbr] = useState(true);

  const location = useLocation();
  //destructuring pathname from location
  const { pathname } = location;
  //getting the name of the path in array
  const splitLocation = pathname.split("/").slice(1).join("/"); // вся строка после первого слэша
  // console.log("splitlocation", splitLocation);

  const [openSettings, setOpenSettings] = useState(false);
  const handleClickOpen = () => {
    setOpenSettings(true);
  };

  return (
    <>
      <div className={"sidebar" + (hideSidebar ? " collapsed" : "")}>
        <div className="sidbarWrapper">
          <div className="sidebarMenu">
            <ul className="sidebarList">
              <Link
                to="/"
                className={
                  "link loginLess" + (splitLocation === "" ? " active" : "")
                }
              >
                <li className="sidebarListItem">
                  <LineStyle className="sidebarIcon" />
                  <SidebarTooltip
                    isSidebarCollapsed={hideSidebar}
                    title="Home"
                  />
                </li>
              </Link>
            </ul>

            <h3 className="sidebarTitle">DeFi</h3>

            <ul className="sidebarList">
              <Link
                to="/charts"
                className={
                  "link" + (splitLocation === "charts" ? " active" : "")
                }
              >
                <li className="sidebarListItem">
                  {/* <Timeline className="sidebarIcon"/> */}
                  {/* <Equalizer className="sidebarIcon" /> */}
                  <TrendingUp className="sidebarIcon" />
                  {/* <label>Charts</label> */}
                  <SidebarTooltip
                    isSidebarCollapsed={hideSidebar}
                    title="Charts"
                  />
                </li>
              </Link>

              <Link
                to="/portfolio"
                className={
                  "link" + (splitLocation === "portfolio" ? " active" : "")
                }
              >
                <li className="sidebarListItem">
                  <AttachMoney className="sidebarIcon" />
                  {/* <label>Portfolio</label> */}
                  <SidebarTooltip
                    isSidebarCollapsed={hideSidebar}
                    title="Portfolio"
                  />
                </li>
              </Link>

              <Link
                to="/wallets/balances"
                className={
                  "link" +
                  (splitLocation === "wallets/balances" ? " active" : "")
                }
              >
                <li className="sidebarListItem">
                  <CurrencyBitcoinIcon className="sidebarIcon" />
                  {/* <label>Notifications</label> */}
                  <SidebarTooltip
                    isSidebarCollapsed={hideSidebar}
                    title="Balances"
                  />
                </li>
              </Link>

              {/* <Link to="/yields" className={"link" + (splitLocation === "yields" ? " active" : "")}>
              <li
                className="sidebarListItem"
              >
                <TrendingUp className="sidebarIcon" />
                <label>Yields</label>
              </li>
            </Link> */}
            </ul>
          </div>

          <div className="sidebarMenu">
            <h3 className="sidebarTitle">Alerts</h3>

            <ul className="sidebarList">
              <Link
                to="/account/notifications"
                className={
                  "link" +
                  (splitLocation === "account/notifications" ? " active" : "")
                }
              >
                <li className="sidebarListItem">
                  <div className="topbarIconContainer">
                    <NotificationsNoneIcon className="sidebarIcon" />
                    {props.notificationCount > 0 && (
                      <span className="topIconBadge">
                        {props.notificationCount}
                      </span>
                    )}
                  </div>
                  <SidebarTooltip
                    isSidebarCollapsed={hideSidebar}
                    title="Notifications"
                  />
                </li>
              </Link>

              <Link
                to="/account/alerts"
                className={
                  "link" + (splitLocation === "account/alerts" ? " active" : "")
                }
              >
                <li className="sidebarListItem">
                  <AddAlertIcon className="sidebarIcon" />
                  <SidebarTooltip
                    isSidebarCollapsed={hideSidebar}
                    title="Alerts"
                  />
                </li>
              </Link>
            </ul>
          </div>

          <div className="sidebarMenu">
            <h3 className="sidebarTitle">Account</h3>

            <ul className="sidebarList">
              <Link
                to="/vaults"
                className={
                  "link loginLess" +
                  (splitLocation === "vaults" ? " active" : "")
                }
              >
                <li className="sidebarListItem">
                  <PlaylistAddCheckOutlinedIcon className="sidebarIcon" />
                  {/* <label>Vaults</label> */}
                  <SidebarTooltip
                    isSidebarCollapsed={hideSidebar}
                    title="Vaults"
                  />
                </li>
              </Link>

              <Link
                to="/wallets"
                className={
                  "link" + (splitLocation === "wallets" ? " active" : "")
                }
              >
                <li className="sidebarListItem">
                  <AccountBalanceWalletOutlinedIcon className="sidebarIcon" />
                  {/* <label>Wallets</label> */}
                  <SidebarTooltip
                    isSidebarCollapsed={hideSidebar}
                    title="Wallets"
                  />
                </li>
              </Link>

              <li
                className="sidebarListItem sidebarSettings"
                //  onClick={setOpenSettings(true)} - too many renders
                onClick={
                  props.userAuthWallet
                    ? handleClickOpen
                    : () =>
                        toast.error("Please connect to Metamask!", {
                          autoClose: 3000,
                        }) //undefined
                }
              >
                <SettingsOutlinedIcon className="sidebarIcon" />
                {/* <label>Settings</label> */}
                <SidebarTooltip
                  isSidebarCollapsed={hideSidebar}
                  title="Settings"
                />
              </li>

              {/* <Link to="/products" className={"link" + (splitLocation === "products" ? " active" : "")}>
              <li className="sidebarListItem">
                <Storefront className="sidebarIcon" />
                <label>Products</label>
              </li>
            </Link>
            <li className="sidebarListItem">
              <Equalizer className="sidebarIcon" />
              <label>Reports</label>
            </li> */}
            </ul>
          </div>

          {/* <div className="sidebarMenu">
          <h3 className="sidebarTitle">Notifications</h3>
          <ul className="sidebarList">
            <li className="sidebarListItem">
              <MailOutline className="sidebarIcon" />
              <label>Mail</label>
            </li>
            <li className="sidebarListItem">
              <DynamicFeed className="sidebarIcon" />
              <label>Feedback</label>
            </li>
            <li className="sidebarListItem">
              <ChatBubbleOutline className="sidebarIcon" />
              <label>Messages</label>
            </li>
          </ul>
        </div>

        <div className="sidebarMenu">
          <h3 className="sidebarTitle">Staff</h3>
          <ul className="sidebarList">
            <li className="sidebarListItem">
              <WorkOutline className="sidebarIcon" />
              <label>Manage</label>
            </li>
            <li className="sidebarListItem">
              <Timeline className="sidebarIcon" />
              <label>Analytics</label>
            </li>
            <li className="sidebarListItem">
              <Report className="sidebarIcon" />
              <label>Reports</label>
            </li>
          </ul>
        </div> */}

          <div className="toggleLink" onClick={toggleSidebar}>
            {/* {hideSidebar ? <MenuIcon /> : <MenuOpenIcon />} */}
            <MenuOpenIcon />
          </div>
        </div>
      </div>

      <SettingsDlg
        userAuthWallet={props.userAuthWallet}
        open={openSettings}
        setOpen={setOpenSettings}
        // settingsWalletAbbr={settingsWalletAbbr}
        // setSettingsWalletAbbr={setSettingsWalletAbbr}
      />
    </>
  );
}
